"use strict";

// eslint-disable-next-line no-unused-vars
function toggleSearchWidget(searchButton) {
  const searchComponent = document.querySelector('.search_component');
  if (!searchComponent) return;
  const searchWrapper = searchComponent.querySelector('.search_wrapper');
  const searchWidget = searchComponent.querySelector('.search_widget');
  searchButton.classList.toggle('is-active');
  searchWrapper?.classList.toggle('hidden');
  if (!searchWidget) return;
  searchWidget.classList.toggle('is-active');
  searchWidget.querySelector('input')?.focus();
}
if (window.location.pathname.includes('/trazi') && !window.isMob) {
  document.addEventListener('DOMContentLoaded', () => {
    const searchComponent = document.querySelector('.search_component');
    if (!searchComponent) return;
    const searchWrapper = searchComponent.querySelector('.search_wrapper');
    const searchButton = searchComponent.querySelector('.search_button');
    const searchWidget = searchComponent.querySelector('.search_widget');
    if (!searchButton?.classList.contains('is-active')) searchButton.classList.add('is-active');
    if (!searchComponent.classList.contains('is-active')) searchComponent.classList.add('is-active');
    if (searchWrapper?.classList.contains('hidden')) searchWrapper.classList.remove('hidden');
    if (!searchWidget?.classList.contains('is-active')) searchWidget.classList.add('is-active');
  });
}